import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Divider,
  Modal,
  Button,
  Form,
  Grid,
} from 'semantic-ui-react';
import NotificationItem from './NotificationItem';
import NotificationIcon from './NotificationIcon';
import Timestamp from './Timestamp';
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../../../actions/flash';

export default class LeadActivity extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    bankCases: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    leadCode: PropTypes.string,
    token: PropTypes.string,
    bookingID: PropTypes.string,
    fetchNewBooking: PropTypes.func,
  }
  static defaultProps = {
    data: [],
    bankCases: [],
    leadCode: '',
    token: '',
    bookingIDL: '',
  }
  constructor(props) {
    super(props);
    this.state = {
      remarkMessage: '',
      ccIDs: [],
      showAddRemark: false,
    };
  }
  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }))
  async submitRemark(data) {
    await this.setLoading(true);
    const { store } = this.context;
    try {
      await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/add_lead_activity/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(data),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: 'Success', message: 'Remark was successfully added.' }));
    if (this.props.fetchNewBooking) this.props.fetchNewBooking()
  }
  isCheckedAll() {
    const { ccIDs } = this.state;
    const { bankCases } = this.props;
    if (ccIDs.length === bankCases.length) return true;
    return false;
  }
  isChecked(item) {
    const { ccIDs } = this.state;
    return ccIDs.includes(item.id);
  }
  handleCheckBoxAll = () => {
    const { bankCases } = this.props;
    const ccIDs = [];
    if (!this.isCheckedAll()) bankCases.forEach(c => ccIDs.push(c.id));
    this.setState({ ccIDs });
  }
  handleCheckBox = (item) => {
    const { ccIDs } = this.state;
    if (this.isChecked(item)) {
      const index = ccIDs.indexOf(item.id);
      if (index > -1) {
        ccIDs.splice(index, 1);
      }
    } else {
      ccIDs.push(item.id);
    }
    this.setState({ ccIDs });
  }
  handleTextAreaChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleOnConfirm = (e) => {
    e.preventDefault();
    const data = {
      code: this.props.leadCode,
      message: this.state.remarkMessage,
      type: 'message',
      ccIDs: this.state.ccIDs,
    };
    this.setState({ showAddRemark: false, remarkMessage: '', ccIDs: [] }, () => {
      this.submitRemark(data);
    });
  }
  handleShowAddRemark = (e) => {
    e.preventDefault();
    this.setState({ showAddRemark: true });
  }
  handleCloseAddRemark = (e) => {
    e.preventDefault();
    this.setState({ showAddRemark: false, remarkMessage: '', ccIDs: [] });
  }
  renderModal() {
    const { bankCases } = this.props;
    const { remarkMessage, showAddRemark } = this.state;
    return (
      <Modal size="tiny" open={showAddRemark}>
        <Modal.Header>Add Remark</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group style={{ marginBottom: '0.2em' }}>
              <textarea
                name="remarkMessage"
                className="semantic-textbox"
                placeholder="Type your message here"
                onChange={this.handleTextAreaChange}
                style={{ resize: 'none', minHeight: '5.5em', maxHeight: '5.5em', width: '100%' }}
                maxLength="160"
                value={remarkMessage}
              />
            </Form.Group>
            <div style={{ textAlign: 'right', marginBottom: '0.25em' }}>
              <small>{remarkMessage.length} of 160 characters</small>
            </div>
            <Form.Group style={{ marginBottom: '0' }}>
              <small style={{ padding: '0.1em' }}>Notify: </small>
              {bankCases && bankCases.length > 0 ?
                bankCases.map((item, idx) => (
                  <Form.Checkbox
                    key={idx}
                    label={item.bank.shortName}
                    onChange={() => this.handleCheckBox(item)}
                    checked={this.isChecked(item)}
                  />
              )) : ''}
              <Form.Checkbox
                label="All"
                onChange={this.handleCheckBoxAll}
                checked={this.isCheckedAll()}
              />
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleCloseAddRemark}>Cancel</Button>
          <Button onClick={this.handleOnConfirm} disabled={remarkMessage === ''} primary icon="checkmark" labelPosition="right" content="Add" />
        </Modal.Actions>
      </Modal>
    );
  }
  render() {
    const { data } = this.props;
    return (
      <div>
        {this.renderModal()}
        {data && data.length > 0 ?
          <div>
            <Divider horizontal>Timeline</Divider>
            <Grid reversed="mobile vertically">
              <Grid.Column mobile={16} tablet={16} computer={14}>
                {data.map((item, index) => (
                  <NotificationItem
                    item={item}
                    key={index}
                    leftComponent={
                      <NotificationIcon
                        status={item.type}
                      />
                    }
                    timestamp={
                      <Timestamp
                        timestamp={item.createdAt}
                        precise
                      />
                    }
                    showFullOnClick
                  />
                ))}
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={2}>
                <Button onClick={this.handleShowAddRemark} fluid primary compact size="small" content="Add Remark" />
              </Grid.Column>
            </Grid>
          </div>
          : ''
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/LeadActivity/LeadActivity.jsx